/* eslint-disable no-undef */
import React, { Component } from 'react'
import { ToastContainer } from 'react-toastify'
import * as Sentry from '@sentry/react'
import HMLBar from '../../commons/HMLBar/HMLBar'
import Head from '../Head/Head'
import Wrapper from '../Wrapper/Wrapper'
import Router from '../Router/Router'
import Routes from '../Routes/Routes'
import Alert from '../../commons/Alert/Alert'
import ToastifyCloseButton from '../../commons/ToastifyCloseButton/ToastifyCloseButton'
import { initialize, captureException } from '../../../lib/sentry'

import 'react-toastify/dist/ReactToastify.css'
import '../../../styles/global.scss'

class App extends Component {
  componentDidMount() {
    initialize()
  }

  componentDidCatch(e) {
    captureException(e)
  }

  render() {
    return (
      <Sentry.ErrorBoundary fallback="Erro interno react">
        <HMLBar />
        <Head />
        <Wrapper>
          <Alert />
          <ToastContainer closeButton={ToastifyCloseButton} hideProgressBar />
          <Router>
            <Routes />
          </Router>
        </Wrapper>
      </Sentry.ErrorBoundary>
    )
  }
}

export default App
